<div class="s__tab-block">
  <div class="s__tab-block__tabs" role="tablist">
    @for (tab of tabs(); track tab.label; let i = $index) {
      <button
        class="s__tab-block__tab"
        [class.s__tab-block__tab--active]="activeIndex() === i"
        role="tab"
        [attr.aria-selected]="activeIndex() === i"
        [attr.aria-controls]="'tabpanel-' + i"
        [attr.tabindex]="activeIndex() === i ? 0 : -1"
        [id]="'tab-' + i"
        (click)="selectTab(i)"
        (keydown)="onKeydown($event, i)"
      >
        {{ tab.label }}
      </button>
    }
  </div>
  <div
    class="s__tab-block__content"
    [class.s__tab-block__content--entering]="entering()"
    role="tabpanel"
    [id]="'tabpanel-' + activeIndex()"
    [attr.aria-labelledby]="'tab-' + activeIndex()"
  >
    @if (activeTab().image) {
      <img class="s__tab-block__image"
           [src]="activeTab().image"
           [alt]="activeTab().imageAlt ?? ''"
           [attr.width]="activeTab().imageWidth ?? null"
           [attr.height]="activeTab().imageHeight ?? null"
           loading="lazy" decoding="async" />
    }
    @if (activeTab().resolvedBlocks?.length) {
      @for (block of activeTab().resolvedBlocks; track $index) {
        <ng-container
          *ngComponentOutlet="block.component; inputs: block.inputs"
        />
      }
    } @else {
      <div class="s__prose" [innerHTML]="activeTab().content"></div>
    }
  </div>
</div>
